import { createReducer, createSelector } from '@reduxjs/toolkit';
import { NOTIFICATIONTYPE_INCLUDE } from '../../constants/api';
import { API_REDUCER } from '../../constants/store';
import {
  getInvitationNotificationsForHearingSuccess,
  getNotificationContentSpecificationForHearingSuccess,
} from '../actions/api';
import { getAttr } from '../helpers/apiHelpers';
import { updateDtoList } from '../helpers/reducerHelpers';
import {
  getIncludedData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';

// -------- Overview --------
// NotificationType is included in the following endpoints
//  - GET /hearing/{hearingId}/invitationNotifications
//  - GET /hearing/{hearingId}/notificationContentSpecification

// -------- Reducer --------
const notificationTypeReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getInvitationNotificationsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const notificationTypes = data.filter(
          (include) => include.type === NOTIFICATIONTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', notificationTypes);
      })
      .addCase(
        getNotificationContentSpecificationForHearingSuccess,
        (state, action) => {
          const data = getIncludedData(action);
          const notificationTypes = data.filter(
            (include) => include.type === NOTIFICATIONTYPE_INCLUDE,
          );
          return updateDtoList(state, 'all', notificationTypes);
        },
      );
  },
);

// -------- Selectors --------
const selectGetAllNotificationTypes = (state) =>
  selectAllFromApiState(state, API_REDUCER.NOTIFICATION_TYPE);

const allNotificationTypesSelector = createSelector(
  selectGetAllNotificationTypes,
  (notificationTypes) => notificationTypes,
);

const notificationTypeByTypeSelector = (type) =>
  createSelector(allNotificationTypesSelector, (notificationTypes) =>
    notificationTypes.find((nt) => getAttr(nt, 'notificationType') === type),
  );

export { notificationTypeByTypeSelector };
export default notificationTypeReducer;
